import React, { useCallback, useState } from 'react';
import ProductTypeService from 'services/ProductTypeService/productTypeService';
import { IInspection } from 'pages/SchedulerList/components/Inspection/Inspection.types';
import AttendanceData from './AttendanceData/AttendanceData';
import CustomerData from './CustomerData/CustomerData';
import VehicleData from './VehicleData/VehicleData';
import * as S from './InformationCard.styles';
import { Label } from 'components/Label/Label';
import InspectionPdfService from 'services/InspectionPdf';

export interface IInformationCardProps {
  inspection: IInspection;
}

const InformationCard = ({ inspection }: IInformationCardProps) => {
  const { product, informations, productType } = inspection;
  const isProductAuto = ProductTypeService.isAuto(productType?.code);
  const [loading, setLoading] = useState(false);

  const hasAttendanceData = !!informations?.length;
  const hasVehicleData = isProductAuto && !!product?.plate;

  const handleGeneratePdf = useCallback(async () => {
    try {
      setLoading(true);
      await InspectionPdfService.downloadInspectionPdf(inspection.id, inspection.code);
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
    } finally {
      setLoading(false);
    }
  }, [inspection]);

  const renderNextCard = (element: JSX.Element) => {
    return (
      <>
        <S.Divider />
        {element}
      </>
    );
  };

  return (
    <S.Content>
      <>
        <div>
          {!!inspection.observation && (
            <>
              <Label htmlFor="observation" testID="label-observation">
                Observação preenchida na abertura
              </Label>
              <S.ObservationText>{inspection.observation}</S.ObservationText>
            </>
          )}
        </div>
        <S.Row>
          <CustomerData inspection={inspection} />
          <S.Button
            testID="button-form"
            type="submit"
            text="Gerar PDF"
            loading={loading}
            fullWidth={false}
            size="medium"
            onClick={handleGeneratePdf}
            loadingSize={30}
            loadingColor="#FFF"
          />
        </S.Row>
        {hasAttendanceData && renderNextCard(<AttendanceData informations={informations} />)}
        {hasVehicleData && renderNextCard(<VehicleData inspection={inspection} />)}
      </>
    </S.Content>
  );
};

export default InformationCard;
